import { render, staticRenderFns } from "./CourseModuleSlidebar.vue?vue&type=template&id=7e745513"
import script from "./CourseModuleSlidebar.vue?vue&type=script&lang=js"
export * from "./CourseModuleSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports